import { render, staticRenderFns } from "./AssetsListHeader.vue?vue&type=template&id=638ab84c&"
import script from "./AssetsListHeader.vue?vue&type=script&lang=js&"
export * from "./AssetsListHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports